export default {
      id: "multi-signature-usage",
      viewBox: "0 0 47 38",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#multi-signature",
      toString: function () {
        return this.url;
      }
    }